import { Box, Tooltip } from "@mui/material";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";

const AIIcon = ({ mode = "light" }) => {
  const isDark = mode === "dark";
  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "999px",
        p: 0.5,
        bgcolor: isDark ? "rgba(255,255,255,0.14)" : "rgba(0,51,102,0.06)",
        border: isDark
          ? "1px solid rgba(255,255,255,0.5)"
          : "1px solid rgba(0,51,102,0.18)",
      }}
    >
      <Tooltip title="AI Reviewed" arrow>
        <AutoFixHighIcon
          sx={{ fontSize: "1rem", color: isDark ? "#ffffff" : "#003366" }}
        />
      </Tooltip>
    </Box>
  );
};

export default AIIcon;
